import { Skeleton } from '@app/components/various/Skeleton/Skeleton';

const COLLAPSED_FILTERS = 4;

export const FiltersPanelSkeleton = () => {
  return (
    <>
      {Array.from({ length: COLLAPSED_FILTERS }).map((_, index) => (
        <div key={index} className="rounded-regular bg-white px-5 py-3">
          <Skeleton type="text" size="medium" />
        </div>
      ))}
    </>
  );
};
